module.exports = __webpack_public_path__ + "media/images/free-icon-2c37b466f414ff1bb8755ec76037dc54.png";